export default function ProgressBar({ percentage, label }) {
  return (
    <div className="mt-2 mb-3">
      <div className="flex justify-between items-center mb-2">
        <span className="text-white text-sm">{label}</span>
        <span className="text-white text-sm font-bold">{percentage}%</span>
      </div>
      <div className="w-full bg-amber-600 rounded-full h-3 overflow-hidden relative">
        <div
          className="bg-blue-500 h-full rounded-full transition-all duration-300 absolute left-0 top-0"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}
